import React from 'react'
import { Radio } from 'antd'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

export default (props) => {
  const { input, field } = props
  return (
    <RadioGroup
      buttonStyle="solid"
      style={{ marginRight: 35 }}
      {...props}
      {...input}
      value={input.value}
      onChange={(event) => { input.onChange(event.target.value) }}
    >
      {field.titleMap.map(option => (<RadioButton value={option.value}>{option.name}</RadioButton>))}
    </RadioGroup>
  )
}
